export const application_id: any = process.env.REACT_APP_APPLICATION_ID;
export const api_key: any = process.env.REACT_APP_API_KEY;
export const api_url: any = process.env.REACT_APP_API_URL; 
export const fusion_url:any = process.env.REACT_APP_FUSION_URL
export const image_url: any = process.env.REACT_APP_IMAGE_URL
// export const fusion_secret :any= process.env.REACT_APP_FUSION_SECRET
// export const hasura_api_url: any = process.env.REACT_APP_HASURA_API_URL;
// export const googlemap_key: any = process.env.GOOGLE_MAP_API_KEY

